import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import { t } from '../../providers';

const TableSortHead = ({ classes, sortBy, sortValue, setSorting }) => {
    const sortHeader = (event, sortBy) => {
        event.preventDefault();
        setSorting(sortBy);
    };

    return (
        <TableHead>
            <TableRow className={classes.row}>
                <TableCell className={classes.username} align="left">
                    {t('user.id')}
                </TableCell>
                <TableCell className={classes.name} align="left">
                    {t('name')}
                </TableCell>
                <TableCell className={classes.vatId} align="left">
                    {t('vat.id')}
                </TableCell>
                <TableCell className={classes.citizenId} align="left">
                    {t('citizen.id')}
                </TableCell>
                <TableCell className={classes.userType} align="left">
                    {t('user.type')}
                </TableCell>
                <TableCell className={classes.currentStatus} align="left">
                    {t('current.status')}
                </TableCell>
                <TableCell className={classes.parentAccount} align="left">
                    {t('parent.account')}
                </TableCell>
                <TableCell className={classes.actions} align="left">
                    {t('options')}
                </TableCell>
            </TableRow>
        </TableHead>
    );
};

export default TableSortHead;
